import styled from 'styled-components';

import { Text } from '../../../../../shared/Typhography';

const Wrapper = styled.div<{ value: boolean }>`
  border-radius: 50%;
  background: ${({ value }) => (value ? '#585CEA' : '#A3A8AE')};
  width: 22px;
  height: 22px;
  text-align: center;
`;

export const AIIcon = ({ value }: { value: boolean }) => {
  return (
    <Wrapper value={value}>
      <Text size={0.85} top="2px" color="#fff">
        {value ? '✓' : 'X'}
      </Text>
    </Wrapper>
  );
};
